import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";

import useGetData from "../../../CustomHooks/useAxios/useGetData";
import DialogBox from "../../../components/UI/DialogBox";
import spin from "../../../assets/icons/spin.png";
import { ASSIGN_MACHINE, ASSIGN_MACHINE_SETUP } from "../apiEndpoints";
import { handleErrMessage } from "../../../functions/handleErrMessage";
import usePostData from "../../../CustomHooks/useAxios/usePostData";
import AssignMachineForm from "../forms/AssignMachineForm";
import MainPageLayout from "../../../layout/MainPageLayout";

const AssignMachinePage = () => {
  const navigate = useNavigate();
  const { data, isLoaded, error, getData } = useGetData();
  const { executePost, loading, formError, setFormError, successResponse } =
    usePostData();

  useEffect(() => {
    getData(ASSIGN_MACHINE_SETUP);
  }, [successResponse]);

  const sendData = async (formValues, reset) => {
    // API calling
    executePost(formValues, ASSIGN_MACHINE, reset);
  };

  return (
    <MainPageLayout headerConfig={{ title: "Assign Machine" }}>
      {isLoaded && !error ? (
        <AssignMachineForm
          machineSetup={data}
          sendData={sendData}
          successResponse={successResponse}
          loading={loading}
          navigate={navigate}
        />
      ) : error ? (
        <DialogBox
          title="Error"
          message={handleErrMessage(error)}
          isErrorHandleButtons={true}
        />
      ) : (
        <DialogBox message="Loading your data" animateIcon={spin} />
      )}
      {formError && (
        <DialogBox
          title="Error"
          btnText="Ok"
          message={handleErrMessage(formError)}
          closeAction={() => setFormError("")}
        />
      )}
    </MainPageLayout>
  );
};

export default AssignMachinePage;
